import { Entity } from '../core/entity.js';
import { drawPlayer } from '../render/player_art.js';

/**
 * 玩家实体：只有数据 + 一个绘制闭包，不含任何玩法逻辑。
 * 逻辑全部在 systems/ 里，方便换成 NPC / 联机角色。
 */
export function createPlayer({ x = 0, y = 0, facing = 'down', name = '居者' } = {}) {
  const e = new Entity({
    name,
    transform: { x, y, w: 14, h: 10 },
    velocity: { x: 0, y: 0 },
    player: { speed: 120, runSpeed: 200, buff: 1 },
    anim: { facing, moving: false, phase: 0 },
    // 姿态：state = stand / sit / lie；on = 坐着的器物 id；z / vz 用于起跳
    pose: { state: 'stand', on: null, z: 0, vz: 0 },
  }, ['player']);

  e.drawable = {
    sortY: undefined, // 用 transform.y 排序（坐下时由 pose 系统改成器物底边）
    draw(ctx, self, view) {
      drawPlayer(ctx, self.transform.x, self.transform.y, {
        facing: self.anim.facing,
        moving: self.anim.moving,
        phase: self.anim.phase,
        time: view.time,
        pose: (self.pose && self.pose.state) || 'stand',
        z: (self.pose && self.pose.z) || 0,
      });
    },
  };
  return e;
}
